export function switchLanguage () {
  const MultLang = navigator.language || navigator.browserLanguage
  let BrowLang = 'en'

  if (/^ja/.test(MultLang)) {
    BrowLang = 'jp'
  }
  if (/^ru/.test(MultLang)) {
    BrowLang = 'ru'
  }
  if (/^mn/.test(MultLang)) {
    BrowLang = 'mn'
  }
  if (/^es/.test(MultLang)) {
    BrowLang = 'es'
  }
  if (/^pt/.test(MultLang)) {
    BrowLang = 'pt'
  }
  if (/^ko/.test(MultLang)) {
    BrowLang = 'kr'
  }
  if (/^th/.test(MultLang)) {
    BrowLang = 'th'
  }
  if (/^zh/.test(MultLang)) {
    BrowLang = 'tc'
  }
  if (/^hi/.test(MultLang)) {
    BrowLang = 'hi'
  }
  if (/^vi/.test(MultLang)) {
    BrowLang = 'vi'
  }
  if (/^pl/.test(MultLang)) {
    BrowLang = 'pl'
  }
  if (/^da/.test(MultLang)) {
    BrowLang = 'da'
  }
  return BrowLang
}
// verify this.country include langCode
export const langCode = ['en', 'ru', 'mn', 'jp', 'es']
